module.exports = __webpack_public_path__ + "img/_0000_图层-2.83550ff9.png";